<template>
  <div class="back_header">
    <van-nav-bar title="SMOK" class="top_bar" fixed @click-left="backHome()">
      <template #title>
        <img class="logo-img" src="../assets/image/smoklogo.png" />
      </template>
      <template #left>
        <van-icon name="arrow-left" size="20" color="#000" />
      </template>
      <template #right>
        <div class="options">
          <van-dropdown-menu>
            <van-dropdown-item title="..." ref="item">
              <van-cell @click="onConfirm" v-clipboard:copy="ACodeStr">
                <div class="options_title">{{ $t("message.Copy_security_code") }}</div>
                <van-icon
                  name="qr"
                  size="20"
                  color="#000"
                  v-clipboard:copy="ACodeStr"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                />
              </van-cell>
              <van-cell @click="changeLanguage()">
                <div class="options_title">{{ $t("message.switch_language") }}</div>
                <van-icon name="exchange" size="20" color="#000" />
              </van-cell>
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  props: {
    ACodeStr: "",
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    backHome() {
      this.$router.push({ name: "bind-home" });
    },
    onConfirm() {
      this.$refs.item.toggle();
    },
    onCopy(e) {
      console.log(e.text);
      this.$notify({ type: "success", message: this.$t("message.copy_a_success") });
    },
    onError(e) {
      console.log(e);
      this.$notify(this.$t("message.copy_a_fail"));
    },
    changeLanguage() {
      this.$refs.item.toggle();
      this.common.language = !this.common.language;
      if (this.common.language) {
        this.$i18n.locale = "cn";
      } else {
        this.$i18n.locale = "en";
      }
    },
  },
};
</script>
<style scoped>
.top_bar {
  height: 54px;
}

.logo-img {
  margin-top: 4px;
  height: 24px;
}

.back_header >>> .van-nav-bar__right {
  padding: 0;
  margin-right: 10px;
}

.back_header >>> .van-dropdown-menu__bar {
  box-shadow: 0 0 0;
}

.back_header >>> .van-dropdown-menu__title::after {
  border: 0;
}

.back_header >>> .van-icon {
  flex: 1;
  vertical-align: middle;
}

.back_header {
  width: 54px;
}

.back_header >>> .van-dropdown-menu__title--active {
  color: #323233;
}

.back_header >>> .van-cell__value {
  display: flex;
}

.options_title {
  font-size: 17px;
  margin-right: 8px;
}
</style>
